import DocumentHandler from "./DocumentHandler.component";

export default DocumentHandler;
